module.exports = __webpack_public_path__ + "img/fu-success.938e2309.png";